import axios from '../../helpers/axios-setup';
import { AccountInfo } from '../../components/pages/staff/types';

export const getAccountInfoById = (id: number | string) => axios.get<AccountInfo>(`/account/company/${id}`);
